import { css } from "styled-components";

export const mobile = (props) => css`
  @media (max-width: 480px) {
    ${props}
  }
`;
